import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";

export default function Box(props) {
  const [item, setPost] = React.useState();

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `https://admin.arabian-industries.net/api/api/collections/entry/group_companies/` +
          props.propID +
          `?token=8c25a7a0819fe42e3a0ddb3adc68b1`,
        {
          method: "get",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );
      await response.json().then(function (response) {
        setPost(response);
        //console.log(response);
      });
    };
    fetchData();
  }, [props.propID]);

  if (!item) return;

  return (
    <div
      style={{
        position: "relative",
        marginBottom: "40px",
      }}
    >
      {item.box_image && (
        <img
          src={`${process.env.REACT_APP_IMG + item.box_image.path}`}
          alt={item.box_title}
          width="85"
          height="110"
          loading="lazy"
          decoding="async"
          className="BackGroudHolder"
        />
      )}

      {item.box_title && (
        <div className="MiddleMe">
          <div className="DataHolderBox">
            <div className="TitleBox">{item.box_title}</div>
            <div
              className="ContBoxColorSlider"
              dangerouslySetInnerHTML={{
                __html: item.box_content,
              }}
            />
          </div>
        </div>
      )}
      {item.box_three && (
        <div className={item.box_three ? "MiddleMe" : "MiddleMeLOW"}>
          {item.box_three.map((single, index) => (
            <div key={index} className="BlockX">
              <div className="BlockHolder">
                <div
                  className="IconHolder"
                  style={{
                    backgroundImage: `url(${
                      process.env.REACT_APP_IMG + single.value.icon.path
                    })`,
                  }}
                ></div>
                <div className="BoxArtBOX">{single.value.title}</div>
                <div
                  className="BoxContnent"
                  dangerouslySetInnerHTML={{
                    __html: single.value.box,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
